import React from 'react'
import DownloadIcon from '../Icons/DownloadIcon'
import CloseIcon from '../Icons/CloseIcon'

const UploadFile = ({
  filename = 'filename.png',
  onClick,
  className = '',
  isLoading = false,
  variant = 'download', // 'download' or 'preview'
  ...props
}) => {
  // Determine if we're using a dark background
  const isDarkBackground = className.includes('bg-v3-black-card');
  const textColor = isDarkBackground ? 'text-v3-black-primary' : 'text-white';
  const iconColor = isDarkBackground ? 'text-v3-black-primary' : 'text-white';
  return (
    <div
      className={`
        font-inter-variable
        inline-flex
        items-center
        gap-v3-xs
        px-v3-sm
        py-v3-xs
          ${className.includes('bg-') ? '' : 'bg-[var(--dt-color-brand-100)]'}
        rounded-full
        transition-colors
        duration-200
        max-w-[350px]
        ${className}
      `}
      {...props}
    >
      {variant === 'preview' ? (
        <CloseIcon
          className={`
            w-4 h-4 ${iconColor} cursor-pointer hover:opacity-80 transition-opacity duration-200
            ${isLoading ? 'opacity-75 cursor-not-allowed' : ''}
          `}
          onClick={!isLoading ? onClick : undefined}
        />
      ) : (
        <div
          className={`
            p-v3-xxs
            rounded-v3-xl
            cursor-pointer
            transition-opacity
            duration-200
            ${isLoading ? 'opacity-75 cursor-not-allowed' : ''}
          `}
          style={{
            background: isDarkBackground
              ? 'rgba(0, 0, 0, 0.20)'
              : 'rgba(255, 255, 255, 0.20)'
          }}
          onClick={!isLoading ? onClick : undefined}
        >
          {isLoading ? (
            <div className=" border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <DownloadIcon className={iconColor} />
          )}
        </div>
      )}
      <span className={`${textColor} font-inter-variable text-sm font-medium leading-[160%] truncate`}>
        {filename}
      </span>
    </div>
  )
}

export default UploadFile